import React from 'react';
import MFEStyles from './mfestyles.css';
import ResetStyles from './Reset.css';

const MFE = () => (
  <>
    <style jsx global>
      {MFEStyles}
    </style>
  </>
);

const Reset = () => (
  <>
    <style jsx global>
      {ResetStyles}
    </style>
  </>
);

function ResetCSS() {
  return (
    <>
      <Reset />
      <MFE />
    </>
  );
}

export default ResetCSS;
